<!--==============================
=            TIMELINE            =
===============================-->
<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Timeline</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Playground
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <timeline1></timeline1>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Small dots
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <smalldots-timeline></smalldots-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Icons DOts
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <icondots-timeline></icondots-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Reverse direction
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <reverse-timeline></reverse-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TIMELINE  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Timeline card
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <timeline-card></timeline-card>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Dense alert
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <dense-timeline></dense-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Opposite slot
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <opposite-timeline></opposite-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Avatar dots
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <avatar-timeline></avatar-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Colored dots
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <colored-timeline></colored-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TIMELINE  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Advanced
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <advanced-timeline></advanced-timeline>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import AdvancedTimeline from "../../components/Apps/Timeline/AdvancedTimeline.vue";
import AvatarTimeline from "../../components/Apps/Timeline/AvatarTimeline.vue";
import ColoredTimeline from "../../components/Apps/Timeline/ColoredTimeline.vue";
import DenseTimeline from "../../components/Apps/Timeline/DenseTimeline.vue";
import IcondotsTimeline from "../../components/Apps/Timeline/IcondotsTimeline.vue";
import ReverseTimeline from "../../components/Apps/Timeline/ReverseTimeline.vue";
import OppositeTimeline from "../../components/Apps/Timeline/OppositeTimeline.vue";
import SmalldotsTimeline from "../../components/Apps/Timeline/SmalldotsTimeline.vue";
import Timeline1 from "../../components/Apps/Timeline/Timeline1.vue";
import TimelineCard from "../../components/Apps/Timeline/TimelineCard.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    AdvancedTimeline,
    AvatarTimeline,
    ColoredTimeline,
    DenseTimeline,
    IcondotsTimeline,
    ReverseTimeline,
    OppositeTimeline,
    SmalldotsTimeline,
    Timeline1,
    TimelineCard
  }
};
</script>
<!--====  End of TIMELINE  ====-->